/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:33:53
 * @modify date 2021-09-09 09:33:53
 * @desc [分享]
 */
import { BaseModel, Encryption } from '@mamba-le/libraries';
import dayjs from 'dayjs';
import jsCookie from 'js-cookie';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';

@BindAll()
export class ClientController {
  /**
   * 值存储
   * @memberof KickoffController
   */
  Model = new BaseModel({ type: 'object', storageKey: 'client' });

  stashUid = null;

  get uid() {
    return this.Model.get('uid', '');
  }

  /**
   * 写入
   */
  onWriteCookie(isForce = false) {
    let uid = jsCookie.get('BP_C_ID');
    if (!uid || isForce) {
      uid = Encryption.uniqueId();
    }
    if (!lodash.eq(uid, this.uid)) {
      jsCookie.set('BP_C_ID', uid, { expires: 7 });
      this.Model.merge({ uid });
    }
  }

  // weappHandle(isForce) {
  // let uid = this.stashId;
  // if (!uid || isForce || this.isAfter7Days(this.timeStamp)) {
  //   uid = Encryption.uniqueId();
  // }
  // if (!lodash.eq(uid, this.stashId)) {
  //   this.Model.merge({ uid, timeStamp: dayjs().valueOf() });
  // }
  // }

  isAfter7Days(targetTimestamp) {
    // 将目标时间戳转换为dayjs对象并加7天
    const sevenDaysLater = dayjs(targetTimestamp).add(7, 'day');
    // 获取当前时间戳
    const now = dayjs().valueOf();
    // 比较当前时间是否在7天之后
    return now > sevenDaysLater.valueOf();
  }
}
